import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

const PayDepositSuccess = () => {
	const query = useQuery();
	const orderNumber = query.get("order_number");

	return (
		<Box sx={{ maxWidth: 500, mx: "auto", mt: 6 }}>
			<Paper sx={{ p: 3 }}>
				<Typography variant="h4" gutterBottom>
					Deposit Successful!
				</Typography>
				<Typography variant="body1" gutterBottom>
					Thank you for your deposit. Your payment was processed successfully.
				</Typography>
				{orderNumber && (
					<Typography variant="body2" sx={{ mt: 2 }}>
						<b>Your Order Number:</b>
						<br />
						<code>{orderNumber}</code>
					</Typography>
				)}
				<Typography variant="body2" sx={{ mt: 3 }}>
					We will contact you soon regarding your order. If you have any
					questions, please reference your session ID above.
				</Typography>
			</Paper>
		</Box>
	);
};

export default PayDepositSuccess;
